import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_SELLERS_ATTEMPT,
  GET_SELLERS_SUCCESS,
  GET_SELLERS_FAILURE,
} from "../constants";

// getSellers actions
const getSellersAttempt = () => ({
  type: GET_SELLERS_ATTEMPT,
});

const getSellersSuccess = (payload: any) => ({
  type: GET_SELLERS_SUCCESS,
  payload,
});

const getSellersFailure = (error: string) => ({
  type: GET_SELLERS_FAILURE,
  payload: {
    error,
  },
});

export const getSellersRequest = (data: any, paramsToAdd: any) => (dispatch: Dispatch) => {
  dispatch(getSellersAttempt());

  const params2 = {
    entity: "sellers",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => {
        res.data.data = res.data.data.map((x: any) => {
            return {...x, joined: `${x.sellerId} - ${x.sellerName}`}
        });
        return res.data;
    })
    .then((payload) => {
      dispatch(getSellersSuccess(payload));
    })
    .catch((error) => {
      dispatch(getSellersFailure(error.message));
    });
};
